import React from 'react';
import { BlankTarget } from "./components/BlankTarget";

export const choreTypes = [
    {
        label: 'Transactional Email',
        value: 1,
        description: <span>Transactional email triggers can now be created and managed from our brand new <BlankTarget href="https://peptalkr.com.au/account/transactional-triggers/" text="transactional email trigger builder" />. The legacy triggers below are still available for you to use, however, we recommend using the new builder (it's pretty cool). <BlankTarget href="http://help.peptalkr.com.au/en/articles/5298875-how-to-use-the-transactional-email-trigger-builder" text="More info" />.</span>
    },
    { label: 'Segment', value: 2 },
    { label: 'Sync', value: 3 },
    { label: 'Test', value: 4 }
];

export const taskNames = [
    { label: 'AppConfirmations', value: 1, choreType: '1' },
    { label: 'DidNotArriveApps', value: 2, choreType: '1' },
    { label: 'SyncUpdates', value: 3, choreType: '3' },
    { label: 'InitialSync', value: 4, choreType: '3' },
    { label: 'AppReminders', value: 5, choreType: '1' },
    { label: 'CancelledApps', value: 8, choreType: '1' },
    { label: 'TestDBConnection', value: 9, choreType: '4' },
    { label: 'UpdateSegment', value: 10, choreType: '2' },
    { label: 'StandardApps', value: 11, choreType: '1' }
];

export const startFrom = {
    Now: { label: 'Constantly', value: 1 },
    StartOfDay: { label: 'Daily', value: 2 }
};

export const roles = {
    Admin: 'Administrator',
    Owner: 'Owner'
};

export const timeZones = [
    "(GMT) Coordinated Universal Time",
    "(GMT+00:00) Dublin, Edinburgh, Lisbon, London",
    "(GMT+00:00) Monrovia, Reykjavik",
    "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
    "(GMT+01:00) Casablanca",
    "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "(GMT+01:00) West Central Africa",
    "(GMT+02:00) Amman",
    "(GMT+02:00) Athens, Bucharest",
    "(GMT+02:00) Beirut",
    "(GMT+02:00) Cairo",
    "(GMT+02:00) Chisinau",
    "(GMT+02:00) Damascus",
    "(GMT+02:00) Gaza, Hebron",
    "(GMT+02:00) Harare, Pretoria",
    "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "(GMT+02:00) Jerusalem",
    "(GMT+02:00) Kaliningrad",
    "(GMT+02:00) Tripoli",
    "(GMT+02:00) Windhoek",
    "(GMT+03:00) Baghdad",
    "(GMT+03:00) Istanbul",
    "(GMT+03:00) Kuwait, Riyadh",
    "(GMT+03:00) Minsk",
    "(GMT+03:00) Moscow, St. Petersburg",
    "(GMT+03:00) Nairobi",
    "(GMT+03:30) Tehran",
    "(GMT+04:00) Abu Dhabi, Muscat",
    "(GMT+04:00) Astrakhan, Ulyanovsk",
    "(GMT+04:00) Baku",
    "(GMT+04:00) Izhevsk, Samara",
    "(GMT+04:00) Port Louis",
    "(GMT+04:00) Tbilisi",
    "(GMT+04:00) Yerevan",
    "(GMT+04:30) Kabul",
    "(GMT+05:00) Ashgabat, Tashkent",
    "(GMT+05:00) Ekaterinburg",
    "(GMT+05:00) Islamabad, Karachi",
    "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "(GMT+05:30) Sri Jayawardenepura",
    "(GMT+05:45) Kathmandu",
    "(GMT+06:00) Astana",
    "(GMT+06:00) Dhaka",
    "(GMT+06:30) Yangon (Rangoon)",
    "(GMT+07:00) Bangkok, Hanoi, Jakarta",
    "(GMT+07:00) Barnaul, Gorno-Altaysk",
    "(GMT+07:00) Krasnoyarsk",
    "(GMT+07:00) Novosibirsk",
    "(GMT+07:00) Tomsk",
    "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "(GMT+08:00) Irkutsk",
    "(GMT+08:00) Kuala Lumpur, Singapore",
    "(GMT+08:00) Perth",
    "(GMT+08:00) Taipei",
    "(GMT+08:00) Ulaanbaatar",
    "(GMT+09:00) Chita",
    "(GMT+09:00) Osaka, Sapporo, Tokyo",
    "(GMT+09:00) Seoul",
    "(GMT+09:00) Yakutsk",
    "(GMT+09:30) Adelaide",
    "(GMT+09:30) Darwin",
    "(GMT+10:00) Brisbane",
    "(GMT+10:00) Canberra, Melbourne, Sydney",
    "(GMT+10:00) Guam, Port Moresby",
    "(GMT+10:00) Hobart",
    "(GMT+10:00) Vladivostok",
    "(GMT+10:30) Lord Howe Island",
    "(GMT+11:00) Bougainville Island",
    "(GMT+11:00) Chokurdakh",
    "(GMT+11:00) Magadan",
    "(GMT+11:00) Solomon Is., New Caledonia",
    "(GMT+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    "(GMT+12:00) Auckland, Wellington",
    "(GMT+12:00) Coordinated Universal Time+12",
    "(GMT+12:00) Fiji",
    "(GMT+12:00) Petropavlovsk-Kamchatsky - Old",
    "(GMT+13:00) Nuku'alofa",
    "(GMT+13:00) Samoa",
    "(GMT+14:00) Kiritimati Island",
    "(GMT-01:00) Azores",
    "(GMT-01:00) Cabo Verde Is.",
    "(GMT-02:00) Coordinated Universal Time-02",
    "(GMT-02:00) Mid-Atlantic - Old",
    "(GMT-03:00) Araguaina",
    "(GMT-03:00) Brasilia",
    "(GMT-03:00) Cayenne, Fortaleza",
    "(GMT-03:00) City of Buenos Aires",
    "(GMT-03:00) Greenland",
    "(GMT-03:00) Montevideo",
    "(GMT-03:00) Salvador",
    "(GMT-03:30) Newfoundland",
    "(GMT-04:00) Asuncion",
    "(GMT-04:00) Atlantic Time (Canada)",
    "(GMT-04:00) Caracas",
    "(GMT-04:00) Cuiaba",
    "(GMT-04:00) Georgetown, La Paz, Manaus, San Juan",
    "(GMT-04:00) Santiago",
    "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    "(GMT-05:00) Chetumal",
    "(GMT-05:00) Eastern Time (US & Canada)",
    "(GMT-05:00) Haiti",
    "(GMT-05:00) Indiana (East)",
    "(GMT-05:00) Turks and Caicos",
    "(GMT-06:00) Central America",
    "(GMT-06:00) Central Time (US & Canada)",
    "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
    "(GMT-06:00) Saskatchewan",
    "(GMT-07:00) Arizona",
    "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    "(GMT-07:00) Mountain Time (US & Canada)",
    "(GMT-08:00) Baja California",
    "(GMT-08:00) Coordinated Universal Time-08",
    "(GMT-08:00) Pacific Time (US & Canada)",
    "(GMT-09:00) Alaska",
    "(GMT-09:00) Coordinated Universal Time-09",
    "(GMT-10:00) Hawaii",
    "(GMT-11:00) Coordinated Universal Time-11",
    "(GMT-12:00) International Date Line West"
];

export const notificationChoreSteps = [
    { step: 'name', value: 1 },
    { step: 'scheduletype', value: 2 },
    { step: 'scheduletype_automated', value: 2.1, reliesOn: { property: 'scheduletype', value: '1' } },
    { step: 'scheduletype_oneoff', value: 2.2, reliesOn: { property: 'scheduletype', value: '2' } },
    { step: 'marketing', value: 3 },
    { step: 'whoto', value: 4 },
    { step: 'whoto_somepatients', value: 4.1, reliesOn: { property: 'whoto', value: '1' } },
    { step: 'when', value: 5 },
    { step: 'when_scheduletype_automated', value: 5.1, reliesOn: { property: 'scheduletype', value: '1' } },
    { step: 'when_scheduletype_oneoff', value: 5.2, reliesOn: { property: 'scheduletype', value: '2' } }
];

export const scheduleTypes = {
    OneOff: { label: 'One-off blast', value: 1, subLabel: 'A message that is sent to selected patients all at once. Perfect for announcements' },
    Recurring: { label: 'Automated recurring', value: 2, subLabel: 'A message that sends itself to selected patients when certain conditions are met' }
};

export const gender = {
    Male: { label: 'Male', value: 1 },
    Female: { label: 'Female', value: 2 }
};

export const ensure = {
    none: 0,
    appointmentCategory: 1,
    practitioner: 2,
    cronExpressions: 4,
    clients: 8,
    appointmentType: 16,
    appointmentModelProperties: 32,
    products: 64,
    smsCredits: 128,
    timeZones: 256,
    business: 512,
    billableItems: 1024,
    sexes: 2048,
    medicalAlerts: 4096,
    cmEmails: 8192,
    ptProducts: 16384,
};

export const when_OneOff = {
    Now: { label: 'Now', value: 1 },
    Scheduled: { label: 'Scheduled Date/Time', value: 2 }
};

export const howOften = {
    EveryTime: { label: 'Every time the conditions are met', value: 3, subLabel: 'This is perfect for things like confirmations where the patient needs to be notified every time an appointment is made' },
    OnceInADay: { label: 'Once in a day', value: 2, subLabel: `If a patient meets the conditions of this mulitple times a day (eg, they have mulitple appointments in a day) we'll only send it once` },
    Once: { label: 'Once ever', value: 1, subLabel: 'No matter how many times the conditions are met, a patient will receive this just once' }
};

export const when_Automated = {
    BeforeNext: { label: 'Before the appointment', value: 1 },
    AfterLast: { label: 'After the appointment', value: 2 },
    AfterCreated: { label: 'After an appointment is created', value: 8 },
    AfterCancelled: { label: 'After an appointment is cancelled', value: 3 },
    AfterDna: { label: 'After an appointment is marked DNA', value: 4 },
    AfterInvoiceCreated: { label: 'After an invoice is created', value: 5, selectedInfo: `You can specify the invoice item and/or product that triggers this message on the next page.` },
    AfterInvoiceClosed: { label: 'After an invoice has been paid', value: 10, selectedInfo: `You can specify the invoice item and/or product that triggers this message on the next page.` },
    AfterMedicalAlertAdded: { label: 'After a medical alert is added to a patient file', value: 9, selectedInfo: 'You can specify the medical alert on the next page.' },
    //Anniversary: { label: 'On the anniversary of a date', value: 6 }
    OnCount: { label: 'When a patient has a certain number of appointments', value: 7, selectedInfo: `The message will send 1 hour after the appointment ends. If you'd like to define the exact amount of time after which it sends, change your trigger to 'After the appoinment'` }
};

export const when_Magntitude = {
    Days: { label: 'Days', value: 1 },
    Hours: { label: 'Hours', value: 3 },
    Minutes: { label: 'Minutes', value: 2 }
};

export const when_MagntitudeBig = {
    Days: { label: 'Days', value: 1 },
    Hours: { label: 'Months', value: 4 }
};

export const when_MagntitudeForever = {
    Forever: { label: 'Forever', value: 5 }
};

export const notificationChoreType = {
    Email: 1,
    Sms: 2
};


export const marketing = {
    Yes: { label: 'Yes', value: true, subLabel: 'Only patients opted in to SMS marketing in their Cliniko profile will receive it' },
    No: { label: 'No', value: false, subLabel: 'This is an important message that should go to all patients' }
};

export const notificationChoreSchedule_Status = {
    Unknown: 0,
    Pending: 1,
    InProgress: 2,
    Complete: 3,
    Cancelled: 4,
    Errored: 5,
    InsufficientCredits: 6,
    Queued: 7
};

export const notificationChore_Status = {
    Unknown: 0,
    Sent: 1,
    Draft: 2,
    Paused: 3,
    Active: 4,
    Scheduled: 5,
    InsufficientCredits: 6,
    InProgress: 7,
    Queued: 8
};

export const initialSync_Status = {
    NotStarted: 0,
    Started: 1,
    Completed: 2,
    Errored: 3
};

export const cancellationReasons = {
    FeelingBetter: { label: 'Feeling Better', value: 10 },
    ConditionWorse: { label: 'Condition Worse', value: 20 },
    Sick: { label: 'Sick', value: 30 },
    Covid: { label: 'COVID-19 related', value: 31 },
    Away: { label: 'Away', value: 40 },
    Other: { label: 'Other', value: 50 },
    Work: { label: 'Work', value: 60 }
};

export const appointmentStatus = {
    Arrived: { label: 'Arrived', value: 1 },
    DidNotArrive: { label: 'Did Not Arrive', value: 2 },
    Cancelled: { label: 'Cancelled', value: 3 }
};

export const activePatientSyncMonths = [
    { label: 'Free Trial Mode (250 limit)', value: -1 },
    { label: 'All', value: '' },
    { label: '6 Months', value: 6 },
    { label: '12 Months', value: 12 },
    { label: '18 Months', value: 18 },
    { label: '24 Months', value: 24 }
];

export const recallFilter = {
    NoFilter: { label: 'Of any kind', value: 0 },
    CategoryTypeFilter: { label: 'Of the same type', value: 1 },
    CategoryFilter: { label: 'Of the same category', value: 2 },
};


export const patientIntakeFormFormat = {
    PatientNotes: { label: 'Treatment Notes', value: 1 },
    Pdf: { label: 'Pdf', value: 2 }
}

export const appointmentCountEquality = {
    AtLeast: { label: 'At least', value: 1 },
    Equal: { label: 'Exactly', value: 2 },
    AtMost: { label: 'At most', value: 3 }
}

export const logLevels = {
    Info: { label: 'Info', value: 2 },
    Error: { label: 'Error', value: 4 }
}


// WEBPACK FOOTER //
// ./src/constants.js